import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';

export const BAGGAGE_ITEM_ADDER_FORM = 'BaggageItemAdderForm';

const BaggageItemAdderModalForm = ({ handleSubmit }) => {
  useEffect(() => {
    const input = document.querySelector('.baggage-item-correlative');
    if (input) input.focus();
  }, []);
  const onSubmit = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    return handleSubmit(e);
  };

  return (
    <Form onSubmit={onSubmit}>
      <FormGroup row>
        <FormItem label="Correlativo del Equipaje" required>
          <Field
            name="correlative"
            component={TextInput}
            type="text"
            placeholder="Escanear o pegar correlativo..."
            className="form-control baggage-item-correlative"
          />
        </FormItem>
      </FormGroup>
    </Form>
  );
};

BaggageItemAdderModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: BAGGAGE_ITEM_ADDER_FORM,
})(BaggageItemAdderModalForm);
